import React, { useState } from 'react';
import { NavLink, useLocation } from 'react-router-dom';
import styles from './Navbar.module.css';
import AlphaBar from '../../AlphaBar/AlphaBar';


const Navbar = () => {

  const [menuOpen, setMenuOpen] = useState(false);
  const location = useLocation();

  const toggleMenu = () => {
    setMenuOpen(!menuOpen);
  };

  const getPageName = () => {
    switch (location.pathname) {
      case '/':
        return 'Home';
      case '/data':
        return 'Dati';
      case '/report':
        return 'Report';
      case '/projects':
        return 'Opportunità';
        case '/settings':
          return 'Impostazioni';
          case '/arrivi':
            return 'Arrivi';
            case '/pianoturistico':
              return 'Piano Turistico';
      default:
        return 'Page Not Found';
    }
  };

  return (
    <div>
    <nav className={styles.navbar}>
    <button
    onClick={toggleMenu}
    className={`${styles.hamburgerButton} ${menuOpen ? styles.open : ''}`}
>
    <span className={styles.middleBar}></span>
</button>
      <div className={`${styles.hamburgerMenu} ${menuOpen ? styles.open : ''}`}>
        <NavLink onClick={toggleMenu} to="/" activeClassName={styles.active} className={styles.navLink}>Home</NavLink>
        <NavLink onClick={toggleMenu} to="/arrivi" activeClassName={styles.active} className={styles.navLink}>Arrivi</NavLink>
        <NavLink onClick={toggleMenu} to="/projects" activeClassName={styles.active} className={styles.navLink}>Opportunità</NavLink>
        <NavLink onClick={toggleMenu} to="/pianoturistico" activeClassName={styles.active} className={styles.navLink}>Piano Turistico</NavLink>
        <NavLink onClick={toggleMenu} to="/report" activeClassName={styles.active} className={styles.navLink}>Report</NavLink>
      
      </div>
      <h1 className={styles.pageName}>{getPageName()}</h1>
      <div className={styles.userAvatar}>
      
    </div>
    </nav>
    <AlphaBar/>
    <br></br>
    </div>
    
  );
};

export default Navbar;